<template>
  <div class="page-header">
    <div class="title">
      <i :class="icon"></i>
      <span>{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  position: relative;
  height: 80px;
  margin: -20px -20px 20px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1890ff, #36cfc9);


  /* 添加科技感背景 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    animation: backgroundMove 20s linear infinite;
  }

  /* 添加动态光效 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -150%;
    width: 150%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.1),
      transparent
    );
    transform: skewX(-20deg);
    animation: shine 8s infinite;
  }

  .title {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    
    i {
      width: 40px;
      height: 40px;
      margin-right: 12px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      backdrop-filter: blur(5px);
    }

    span {
      font-size: 20px;
      font-weight: 500;
      color: #fff;
      text-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
  }
}

@keyframes backgroundMove {
  0% {
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  }
  100% {
    background-position: -20px -20px, -20px -10px, -10px -30px, -30px -20px;
  }
}

@keyframes shine {
  0% {
    left: -150%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}
</style> 